import { render, staticRenderFns } from "./BarPie.vue?vue&type=template&id=285f91b8&"
import script from "./BarPie.vue?vue&type=script&lang=js&"
export * from "./BarPie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports